import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { ApiError, onApiError } from '@/api/httpClient'
import { morphToast } from '@/components/ui/Toast'
import { usePlanDialogStore } from '@/stores/planDialogStore'
import { buildLoginRedirect } from '@/utils/authRedirect'
import { shouldOpenPlanDialogForError } from '@/utils/planDialogErrors'

export function GlobalErrorListener() {
  const navigate = useNavigate()
  const location = useLocation()
  const openPlanDialog = usePlanDialogStore((s) => s.openDialog)

  useEffect(() => {
    return onApiError((error: ApiError) => {
      if (error.status === 401) {
        const next = `${location.pathname}${location.search}`
        navigate(buildLoginRedirect(next), { replace: true })
        return
      }
      if (shouldOpenPlanDialogForError(error.code)) {
        openPlanDialog()
      }
      morphToast.fromError(error)
    })
  }, [location.pathname, location.search, navigate, openPlanDialog])

  return null
}
